import { Fragment } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import GlobalFooter from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";
import { ConfluencePageBanner } from "@/templates/confluence-software-page/src/sections/banner";

import { LeftLines } from "./graphics/left-lines";
import { RightLines } from "./graphics/right-lines";
import ConfluenceSoftwareNav from "./sections/software-confluence-navbar";
import CtaSection from "./sections/variant-expcen-4531/cta";
import FeaturesSection from "./sections/variant-expcen-4531/features";
import HeroSection from "./sections/variant-expcen-4531/hero";
import IntegrationsSection from "./sections/variant-expcen-4531/integrations";
import ResourcesSection from "./sections/variant-expcen-4531/resources";
import SocialProofShort from "./sections/variant-expcen-4531/social-proof-short";
import TemplatesSection from "./sections/variant-expcen-4531/templates";
import TestimonialsSection from "./sections/variant-expcen-4531/testimonials";
import VideoSection from "./sections/variant-expcen-4531/video";
import WhyConfluenceSection from "./sections/variant-expcen-4531/why-confluence";

const backgroundStyle = css({
    background:
        "linear-gradient(180deg, #b3d4ff 0%, rgba(179, 212, 255, 0) 100%)",
    overflow: "visible",
    position: "absolute",
    insetBlockStart: 0,
    insetInlineStart: 0,
    width: "100%",
    height: "100%",
    [media.only.xxs]: {
        maxHeight: "1045px"
    },
    [media.only.xs]: {
        maxHeight: "1160px"
    },
    [media.only.sm]: {
        maxHeight: "1160px"
    },
    [media.above.md]: {
        maxHeight: "965px"
    }
});

const leftLines = css({
    position: "absolute",
    insetBlockStart: 182,

    [media.below.sm]: {
        display: "none"
    },

    [media.only.sm]: {
        insetBlockStart: 200
    }
});
const rightLines = css({
    position: "absolute",
    insetBlockStart: 672,
    insetInlineEnd: 0,

    [media.below.sm]: {
        display: "none"
    },

    [media.only.sm]: {
        insetBlockStart: 645
    }
});

const relative = css({
    position: "relative"
});

export const ConfluenceSoftwarePageExpcen4531 = () => {
    return (
        <Fragment>
            <div>
                <GlobalNavigation
                    showTryNow={false}
                    color={"#f4f5f7"}
                    productKey="confluence"
                />
            </div>
            <ConfluenceSoftwareNav />
            <ConfluencePageBanner />
            <div css={relative}>
                <div css={backgroundStyle} />
                <div css={leftLines}>
                    <LeftLines />
                </div>
                <div css={rightLines}>
                    <RightLines />
                </div>
                <div css={relative}>
                    <HeroSection />
                    <FeaturesSection />
                    <SocialProofShort />
                    <VideoSection />
                    <TemplatesSection />
                    <WhyConfluenceSection />
                    <IntegrationsSection />
                    <TestimonialsSection />
                    <ResourcesSection />
                    <CtaSection />
                </div>
            </div>
            <GlobalFooter />
        </Fragment>
    );
};
